export var OMUK;
(function (OMUK) {
    OMUK["OMUK_1"] = "OMUK_1";
    OMUK["OMUK_1_1"] = "OMUK_1_1";
    OMUK["OMUK_1_1_1"] = "OMUK_1_1_1";
    OMUK["OMUK_1_1_2"] = "OMUK_1_1_2";
    OMUK["OMUK_1_2"] = "OMUK_1_2";
    OMUK["OMUK_1_2_1"] = "OMUK_1_2_1";
    OMUK["OMUK_1_2_2"] = "OMUK_1_2_2";
    OMUK["OMUK_1_2_3"] = "OMUK_1_2_3";
    OMUK["OMUK_1_2_4"] = "OMUK_1_2_4";
    OMUK["OMUK_1_2_5"] = "OMUK_1_2_5";
    OMUK["OMUK_1_2_6"] = "OMUK_1_2_6";
    OMUK["OMUK_1_3"] = "OMUK_1_3";
    OMUK["OMUK_1_4"] = "OMUK_1_4";
    OMUK["OMUK_1_4_1"] = "OMUK_1_4_1";
    OMUK["OMUK_1_4_2"] = "OMUK_1_4_2";
    OMUK["OMUK_1_4_3"] = "OMUK_1_4_3";
    OMUK["OMUK_1_5"] = "OMUK_1_5";
    OMUK["OMUK_1_5_1"] = "OMUK_1_5_1";
    OMUK["OMUK_1_5_2"] = "OMUK_1_5_2";
    OMUK["OMUK_1_5_3"] = "OMUK_1_5_3";
    OMUK["OMUK_1_5_4"] = "OMUK_1_5_4";
    OMUK["OMUK_1_5_5"] = "OMUK_1_5_5";
    OMUK["OMUK_2"] = "OMUK_2";
    OMUK["OMUK_2_1"] = "OMUK_2_1";
    OMUK["OMUK_2_2"] = "OMUK_2_2";
    OMUK["OMUK_2_3"] = "OMUK_2_3";
    OMUK["OMUK_2_4"] = "OMUK_2_4";
    OMUK["OMUK_2_5"] = "OMUK_2_5";
    OMUK["OMUK_2_6"] = "OMUK_2_6";
    OMUK["OMUK_2_7"] = "OMUK_2_7";
    OMUK["OMUK_3"] = "OMUK_3";
    OMUK["OMUK_3_1"] = "OMUK_3_1";
    OMUK["OMUK_3_2"] = "OMUK_3_2";
    OMUK["OMUK_3_3"] = "OMUK_3_3";
    OMUK["OMUK_3_4"] = "OMUK_3_4";
    OMUK["OMUK_3_5"] = "OMUK_3_5";
    OMUK["OMUK_3_6"] = "OMUK_3_6";
    OMUK["OMUK_3_7"] = "OMUK_3_7";
    OMUK["OMUK_3_8"] = "OMUK_3_8";
    OMUK["OMUK_4"] = "OMUK_4";
    OMUK["OMUK_4_1"] = "OMUK_4_1";
    OMUK["OMUK_4_1_1"] = "OMUK_4_1_1";
    OMUK["OMUK_4_1_2"] = "OMUK_4_1_2";
    OMUK["OMUK_4_1_3"] = "OMUK_4_1_3";
    OMUK["OMUK_4_1_4"] = "OMUK_4_1_4";
    OMUK["OMUK_4_2"] = "OMUK_4_2";
    OMUK["OMUK_4_2_1"] = "OMUK_4_2_1";
    OMUK["OMUK_4_2_2"] = "OMUK_4_2_2";
    OMUK["OMUK_4_2_3"] = "OMUK_4_2_3";
    OMUK["OMUK_4_2_4"] = "OMUK_4_2_4";
    OMUK["OMUK_4_3"] = "OMUK_4_3";
    OMUK["OMUK_4_3_1"] = "OMUK_4_3_1";
    OMUK["OMUK_4_3_2"] = "OMUK_4_3_2";
    OMUK["OMUK_4_3_3"] = "OMUK_4_3_3";
    OMUK["OMUK_4_3_4"] = "OMUK_4_3_4";
    OMUK["OMUK_4_4"] = "OMUK_4_4";
    OMUK["OMUK_4_4_1"] = "OMUK_4_4_1";
    OMUK["OMUK_4_4_2"] = "OMUK_4_4_2";
    OMUK["OMUK_4_4_3"] = "OMUK_4_4_3";
    OMUK["OMUK_4_4_4"] = "OMUK_4_4_4";
    OMUK["OMUK_4_5"] = "OMUK_4_5";
    OMUK["OMUK_4_5_1"] = "OMUK_4_5_1";
    OMUK["OMUK_4_5_2"] = "OMUK_4_5_2";
    OMUK["OMUK_4_5_3"] = "OMUK_4_5_3";
    OMUK["OMUK_4_5_4"] = "OMUK_4_5_4";
    OMUK["OMUK_4_6"] = "OMUK_4_6";
    OMUK["OMUK_4_6_1"] = "OMUK_4_6_1";
    OMUK["OMUK_4_6_2"] = "OMUK_4_6_2";
    OMUK["OMUK_4_6_3"] = "OMUK_4_6_3";
    OMUK["OMUK_4_6_4"] = "OMUK_4_6_4";
    OMUK["OMUK_4_7"] = "OMUK_4_7";
    OMUK["OMUK_4_7_1"] = "OMUK_4_7_1";
    OMUK["OMUK_4_7_2"] = "OMUK_4_7_2";
    OMUK["OMUK_4_7_3"] = "OMUK_4_7_3";
    OMUK["OMUK_4_7_4"] = "OMUK_4_7_4";
    OMUK["OMUK_4_8"] = "OMUK_4_8";
    OMUK["OMUK_4_8_1"] = "OMUK_4_8_1";
    OMUK["OMUK_5"] = "OMUK_5";
    OMUK["OMUK_5_1"] = "OMUK_5_1";
    OMUK["OMUK_5_1_1"] = "OMUK_5_1_1";
    OMUK["OMUK_5_1_2"] = "OMUK_5_1_2";
    OMUK["OMUK_5_1_3"] = "OMUK_5_1_3";
    OMUK["OMUK_5_1_4"] = "OMUK_5_1_4";
    OMUK["OMUK_5_2"] = "OMUK_5_2";
    OMUK["OMUK_5_2_1"] = "OMUK_5_2_1";
    OMUK["OMUK_5_2_2"] = "OMUK_5_2_2";
    OMUK["OMUK_5_2_3"] = "OMUK_5_2_3";
    OMUK["OMUK_5_2_4"] = "OMUK_5_2_4";
    OMUK["OMUK_5_3"] = "OMUK_5_3";
    OMUK["OMUK_5_3_1"] = "OMUK_5_3_1";
    OMUK["OMUK_5_3_2"] = "OMUK_5_3_2";
    OMUK["OMUK_5_3_3"] = "OMUK_5_3_3";
    OMUK["OMUK_5_3_4"] = "OMUK_5_3_4";
    OMUK["OMUK_5_4"] = "OMUK_5_4";
    OMUK["OMUK_5_4_1"] = "OMUK_5_4_1";
    OMUK["OMUK_5_4_2"] = "OMUK_5_4_2";
    OMUK["OMUK_5_4_3"] = "OMUK_5_4_3";
    OMUK["OMUK_5_4_4"] = "OMUK_5_4_4";
    OMUK["OMUK_5_5"] = "OMUK_5_5";
    OMUK["OMUK_5_5_1"] = "OMUK_5_5_1";
    OMUK["OMUK_5_5_2"] = "OMUK_5_5_2";
    OMUK["OMUK_5_5_3"] = "OMUK_5_5_3";
    OMUK["OMUK_5_5_4"] = "OMUK_5_5_4";
    OMUK["OMUK_5_6"] = "OMUK_5_6";
    OMUK["OMUK_5_6_1"] = "OMUK_5_6_1";
    OMUK["OMUK_5_6_2"] = "OMUK_5_6_2";
    OMUK["OMUK_5_6_3"] = "OMUK_5_6_3";
    OMUK["OMUK_5_7"] = "OMUK_5_7";
    OMUK["OMUK_5_7_1"] = "OMUK_5_7_1";
    OMUK["OMUK_5_7_2"] = "OMUK_5_7_2";
    OMUK["OMUK_5_7_3"] = "OMUK_5_7_3";
    OMUK["OMUK_5_8"] = "OMUK_5_8";
    OMUK["OMUK_5_8_1"] = "OMUK_5_8_1";
    OMUK["OMUK_5_8_2"] = "OMUK_5_8_2";
    OMUK["OMUK_5_8_3"] = "OMUK_5_8_3";
    OMUK["OMUK_5_9"] = "OMUK_5_9";
    OMUK["OMUK_5_9_1"] = "OMUK_5_9_1";
    OMUK["OMUK_5_9_2"] = "OMUK_5_9_2";
    OMUK["OMUK_5_9_3"] = "OMUK_5_9_3";
    OMUK["OMUK_5_9_4"] = "OMUK_5_9_4";
    OMUK["OMUK_5_9_5"] = "OMUK_5_9_5";
    OMUK["OMUK_5_10"] = "OMUK_5_10";
    OMUK["OMUK_5_10_1"] = "OMUK_5_10_1";
    OMUK["OMUK_5_10_2"] = "OMUK_5_10_2";
    OMUK["OMUK_5_10_3"] = "OMUK_5_10_3";
    OMUK["OMUK_5_10_4"] = "OMUK_5_10_4";
    OMUK["OMUK_5_10_5"] = "OMUK_5_10_5";
    OMUK["OMUK_5_11"] = "OMUK_5_11";
    OMUK["OMUK_5_11_1"] = "OMUK_5_11_1";
    OMUK["OMUK_5_11_2"] = "OMUK_5_11_2";
    OMUK["OMUK_5_11_3"] = "OMUK_5_11_3";
    OMUK["OMUK_5_11_4"] = "OMUK_5_11_4";
    OMUK["OMUK_5_12"] = "OMUK_5_12";
    OMUK["OMUK_5_12_1"] = "OMUK_5_12_1";
    OMUK["OMUK_5_12_2"] = "OMUK_5_12_2";
    OMUK["OMUK_5_12_3"] = "OMUK_5_12_3";
    OMUK["OMUK_5_12_4"] = "OMUK_5_12_4";
    OMUK["OMUK_5_13"] = "OMUK_5_13";
    OMUK["OMUK_5_13_1"] = "OMUK_5_13_1";
    OMUK["OMUK_5_13_2"] = "OMUK_5_13_2";
    OMUK["OMUK_5_13_3"] = "OMUK_5_13_3";
    OMUK["OMUK_5_13_4"] = "OMUK_5_13_4";
    OMUK["OMUK_5_14"] = "OMUK_5_14";
    OMUK["OMUK_5_14_1"] = "OMUK_5_14_1";
    OMUK["OMUK_5_14_2"] = "OMUK_5_14_2";
    OMUK["OMUK_5_14_3"] = "OMUK_5_14_3";
    OMUK["OMUK_5_14_4"] = "OMUK_5_14_4";
    OMUK["OMUK_5_15"] = "OMUK_5_15";
    OMUK["OMUK_5_15_1"] = "OMUK_5_15_1";
    OMUK["OMUK_5_15_2"] = "OMUK_5_15_2";
    OMUK["OMUK_5_15_3"] = "OMUK_5_15_3";
    OMUK["OMUK_5_15_4"] = "OMUK_5_15_4";
    OMUK["OMUK_5_15_5"] = "OMUK_5_15_5";
    OMUK["OMUK_5_16"] = "OMUK_5_16";
    OMUK["OMUK_5_16_1"] = "OMUK_5_16_1";
    OMUK["OMUK_5_16_2"] = "OMUK_5_16_2";
    OMUK["OMUK_5_16_3"] = "OMUK_5_16_3";
    OMUK["OMUK_5_16_4"] = "OMUK_5_16_4";
    OMUK["OMUK_5_17"] = "OMUK_5_17";
    OMUK["OMUK_5_17_1"] = "OMUK_5_17_1";
    OMUK["OMUK_5_17_2"] = "OMUK_5_17_2";
    OMUK["OMUK_5_17_3"] = "OMUK_5_17_3";
    OMUK["OMUK_5_17_4"] = "OMUK_5_17_4";
    OMUK["OMUK_5_18"] = "OMUK_5_18";
    OMUK["OMUK_5_18_1"] = "OMUK_5_18_1";
    OMUK["OMUK_5_18_2"] = "OMUK_5_18_2";
    OMUK["OMUK_5_18_3"] = "OMUK_5_18_3";
    OMUK["OMUK_5_18_4"] = "OMUK_5_18_4";
    OMUK["OMUK_5_19"] = "OMUK_5_19";
    OMUK["OMUK_5_19_1"] = "OMUK_5_19_1";
    OMUK["OMUK_5_19_2"] = "OMUK_5_19_2";
    OMUK["OMUK_5_19_3"] = "OMUK_5_19_3";
    OMUK["OMUK_5_19_4"] = "OMUK_5_19_4";
    OMUK["OMUK_5_20"] = "OMUK_5_20";
    OMUK["OMUK_5_20_1"] = "OMUK_5_20_1";
    OMUK["OMUK_5_20_2"] = "OMUK_5_20_2";
    OMUK["OMUK_5_20_3"] = "OMUK_5_20_3";
    OMUK["OMUK_5_20_4"] = "OMUK_5_20_4";
    OMUK["OMUK_5_21"] = "OMUK_5_21";
    OMUK["OMUK_5_21_1"] = "OMUK_5_21_1";
    OMUK["OMUK_5_21_2"] = "OMUK_5_21_2";
    OMUK["OMUK_5_21_3"] = "OMUK_5_21_3";
    OMUK["OMUK_5_21_4"] = "OMUK_5_21_4";
    OMUK["OMUK_5_21_5"] = "OMUK_5_21_5";
    OMUK["OMUK_5_21_6"] = "OMUK_5_21_6";
    OMUK["OMUK_5_21_7"] = "OMUK_5_21_7";
    OMUK["OMUK_5_21_8"] = "OMUK_5_21_8";
    OMUK["OMUK_5_21_9"] = "OMUK_5_21_9";
    OMUK["OMUK_5_21_10"] = "OMUK_5_21_10";
    OMUK["OMUK_5_21_11"] = "OMUK_5_21_11";
    OMUK["OMUK_6"] = "OMUK_6";
    OMUK["OMUK_6_1"] = "OMUK_6_1";
    OMUK["OMUK_6_2"] = "OMUK_6_2";
    OMUK["UNCATEGORIZED"] = "UNCATEGORIZED";
})(OMUK || (OMUK = {}));
